import React from "react";
import { PageHeader } from "./../Components";
import get_about_us from "actions/get_about_us";
import get_teams from "actions/get_teams";
import { baseUrl } from "env";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Col } from "Components";
import ReactHtmlParser from "react-html-parser";
class PersonalBanking extends React.PureComponent {
  state = {
    currentTab: {
      title: "",
      content: []
    }
  };
  async componentDidMount() {
    await this.props.get_about_us();
    await this.props.get_teams();
    this.setState({
      currentTab: this.props.data[0]
    });
  }
  navigate = item => {
    this.setState({
      currentTab: item
    });
  };
  render = () => (
    <div>
      <PageHeader headerClass={"about_us"} pageName="Hakkımızda" />
      <div className="container about_us_wrapper mt80 mb80">
        <Col l={8} m={12}>
          <p className="title">{this.state.currentTab.title}</p>

          {this.state.currentTab.content_html
            ? ReactHtmlParser(this.state.currentTab.content_html)
            : null}
          {this.state.currentTab.teams ? (
            <ul className="team">
              {this.props.teams.map(team => (
                <li>
                  <div className="image_holder">
                    <img
                      alt=""
                      src={`${baseUrl}/api/media/media/${
                        team.profile_photo_media_id
                      }`}
                    />
                  </div>
                  <div className="content_holder">
                    <p className="name">{team.name}</p>
                    <p className="title">{team.title}</p>
                    <p className="description">{team.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : null}
          {this.state.currentTab.media_id ? (
            <img
              alt=""
              src={`${baseUrl}/api/media/media/${
                this.state.currentTab.media_id
              }`}
            />
          ) : null}
        </Col>
        <Col l={4} m={12} className="navigation_tab">
          <ul>
            {this.props.data.map((item, key) => (
              <li
                className={
                  this.state.currentTab.title === item.title ? "active" : ""
                }
                onClick={() => this.navigate(item)}
                key={key}
              >
                {item.title}
              </li>
            ))}
          </ul>
        </Col>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  data: state.about_us ? state.about_us.data : [],
  teams: state.teams
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_about_us,
      get_teams
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalBanking);
